import Reveal from "@/components/Reveal";
import { SITE } from "@/data/site";

const RATES = {
  "paper-crane": [
    { duration: "30 min", price: "$95", desc: "Perfect for 1 area; not suitable for full-body treatments.", note: null },
    { duration: "45 min", price: "$115", desc: "Perfect for 1–2 areas; not suitable for full-body treatments.", note: "Select RMTs only" },
    { duration: "60 min", price: "$133.33", desc: "Perfect for specific or deep work on 1–2 areas, or very general full-body relaxation.", note: null },
    { duration: "90 min", price: "$199.99", desc: "Perfect for deeper work, several areas of concern, or full body relaxation.", note: "Select RMTs only" },
  ],
  "west-end": [
    { duration: "45 min", price: "$115", desc: null, note: null },
    { duration: "60 min", price: "$140", desc: null, note: null },
    { duration: "75 min", price: "$165", desc: null, note: null },
    { duration: "90 min", price: "$195", desc: null, note: null },
  ],
};

const MSP_RATES = [
  { duration: "45 min", price: "$92" },
  { duration: "60 min", price: "$117" },
];

function RateRow({ r, clinicId }) {
  return (
    <div
      className="group flex items-baseline justify-between gap-6 border-b border-forest/10 py-5 transition-colors duration-500 hover:border-pine/40"
      data-testid={`rate-${clinicId}-${r.duration.replace(" ", "-")}`}
    >
      <div>
        <p className="font-serif text-2xl font-light tracking-tight text-forest transition-transform duration-500 group-hover:translate-x-1.5 lg:text-3xl">
          {r.duration}
        </p>
        {r.note && <p className="mt-1 text-xs uppercase tracking-[0.2em] text-clay">{r.note}</p>}
        {r.desc && <p className="mt-2 max-w-xs text-sm leading-relaxed text-forest/60">{r.desc}</p>}
      </div>
      <p className="font-serif text-2xl font-light tracking-tight text-pine lg:text-3xl" data-testid={`rate-price-${clinicId}-${r.duration.replace(" ", "-")}`}>
        {r.price}
      </p>
    </div>
  );
}

export default function Rates() {
  return (
    <section id="rates" data-testid="rates-section" className="py-24 lg:py-32">
      <div className="mx-auto max-w-[1400px] px-6 lg:px-12">
        <Reveal>
          <p className="mb-6 flex items-center gap-3 text-xs uppercase tracking-[0.25em] text-clay">
            <span className="h-px w-10 bg-clay" /> Rates
          </p>
          <div className="flex flex-wrap items-end justify-between gap-8">
            <h2 className="max-w-xl font-serif text-4xl font-light leading-tight tracking-tighter text-forest sm:text-5xl" data-testid="rates-heading">
              Know what to expect before you book.
            </h2>
            <p className="max-w-sm text-sm leading-relaxed text-forest/60">
              Initial and return visits are the same rate. Direct billing
              available to most extended health plans — you only pay any
              remaining balance.
            </p>
          </div>
        </Reveal>

        <div className="mt-16 grid grid-cols-1 gap-16 lg:grid-cols-2 lg:gap-12">
          {SITE.locations.map((loc, i) => (
            <Reveal key={loc.id} delay={i * 0.12}>
              <div data-testid={`rates-${loc.id}`}>
                <p className="text-xs uppercase tracking-[0.25em] text-clay">{loc.area}</p>
                <h3 className="mt-3 font-serif text-3xl font-light tracking-tight text-forest">{loc.clinic}</h3>
                <div className="mt-8">
                  {RATES[loc.id].map((r) => (
                    <RateRow key={r.duration} r={r} clinicId={loc.id} />
                  ))}
                </div>
                {loc.id === "west-end" && (
                  <div className="mt-8 border border-forest/10 bg-sand/40 p-6" data-testid="rates-msp">
                    <p className="text-xs uppercase tracking-[0.25em] text-clay">MSP supplementary benefits</p>
                    <div className="mt-4 flex flex-wrap gap-x-10 gap-y-2">
                      {MSP_RATES.map((m) => (
                        <p key={m.duration} className="text-sm text-forest/70" data-testid={`rate-msp-${m.duration.replace(" ", "-")}`}>
                          {m.duration} — <span className="font-medium text-forest">{m.price}</span>
                        </p>
                      ))}
                    </div>
                  </div>
                )}
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
